import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";

import { GeolocationDrawer, GeolocationDrawerProps } from "@app/scripts/react-geolocation/components/GeolocationDrawer";
import { GeolocationPopup, GeolocationProps } from "@app/scripts/react-geolocation/components/GeolocationPopup";

const detectCountry = async () => {
  const res = await axios.get("/browsing_context_suggestions.json");
  const detectedCountry = res?.data?.detected_values?.country?.handle;
  localStorage.setItem("detectedCountry", res?.data?.detected_values?.country?.handle);
  return detectedCountry;
};

const GeolocationElem = class extends HTMLElement {
  async connectedCallback() {
    const cachedResult = localStorage.getItem(`detectedCountry`);
    let props = {} as GeolocationProps;

    try {
      props = JSON.parse(this.querySelector("[data-json]")?.innerHTML);
    } catch (error) {
      console.error(error);
    }

    props.detectedCountry = cachedResult || (await detectCountry());
    props.shopifyCountry = Shopify.country;
    props.shouldOpenPopup =
      props.detectedCountry !== Shopify.country && sessionStorage.getItem(`geoPopupClosed`) !== "true";

    const root = ReactDOM.createRoot(this);
    root.render(<GeolocationPopup {...props} />);
  }
};

customElements.define("geolocation-popup", GeolocationElem);

const GeolocationDrawerElem = class extends HTMLElement {
  async connectedCallback() {
    const detectedCountry = await detectCountry();

    let props = {} as GeolocationDrawerProps;

    props.detectedCountry = detectedCountry;
    props.shopifyCountry = Shopify.country;

    const root = ReactDOM.createRoot(this);
    root.render(<GeolocationDrawer {...props} />);
  }
};

customElements.define("geolocation-drawer", GeolocationDrawerElem);
